import React from 'react'
import { useTranslation } from 'react-i18next'
import { SECTION } from 'utils/section'
import classnames from 'classnames'
import symbol from 'assets/img/symbol-white.svg'
import draw from 'assets/img/timeline_draw.jpg'
import exploded from 'assets/img/timeline_exploded_view.jpg'
import styles from './Timeline.module.scss'

export const Timeline = () => {
  const { t } = useTranslation()
  return (
    <section id={SECTION.CONCEPT} className={styles['section']}>
      <div className={styles['container']}>
        <img className={styles['symbol']} src={symbol} alt="PreFor" />
        <h5 className={styles['slogan']}>{t('company.slogan')}</h5>
        <h2 className={styles['title']}>{t('timeline.title')}</h2>
        <div className={styles['content']}>
          <div className={styles['row']}>
            <div className={classnames({
              [styles['cell']]: true,
              [styles['cell-square']]: true
            })}>
              <div className={classnames({
                [styles['arrow']]: true,
                [styles['arrow-right']]: true,
              })}></div>
              <h2>2017</h2>
            </div>
            <div className={classnames({[styles['cell']]: true, [styles['cell-rest']]: true})}>
              <div className={classnames({
                [styles['arrow']]: true,
                [styles['arrow-down']]: true,
              })}></div>
              <div className={classnames({
                [styles['arrow']]: true,
                [styles['arrow-down-mobile']]: true,
              })}></div>
              <h5>2017</h5>
              {t('timeline.text2017')}
            </div>
          </div>
          <div className={styles['row']}>
            <div className={classnames({[styles['cell']]: true, [styles['cell-rest']]: true})}>
              <div className={classnames({
                [styles['arrow']]: true,
                [styles['arrow-down']]: true,
              })}></div>
              <div className={classnames({
                [styles['arrow']]: true,
                [styles['arrow-down-mobile']]: true,
              })}></div>
              <h5>2019</h5>
              {t('timeline.text2019')}
            </div>
            <div className={classnames({[styles['cell']]: true, [styles['cell-square']]: true})}>
              <div className={classnames({
                [styles['arrow']]: true,
                [styles['arrow-left']]: true,
              })}></div>
              <h2>2019</h2>
            </div>
          </div>
          <div className={styles['row']}>
            <div className={classnames({[styles['cell']]: true, [styles['cell-square']]: true})}>
              <div className={classnames({
                [styles['arrow']]: true,
                [styles['arrow-right']]: true,
              })}></div>
              <h2>2022</h2>
            </div>
            <div className={classnames({[styles['cell']]: true, [styles['cell-rest']]: true})}>
              <div className={classnames({
                [styles['arrow']]: true,
                [styles['arrow-right']]: true,
              })}></div>
              <div className={classnames({
                [styles['arrow']]: true,
                [styles['arrow-down-mobile']]: true,
              })}></div>
              <h5>2022</h5>
              {t('timeline.text2022')}
            </div>
            <div className={classnames({[styles['cell']]: true, [styles['cell-square']]: true})}>
              <div className={classnames({
                [styles['arrow']]: true,
                [styles['arrow-down']]: true,
              })}></div>
              <img src={draw} alt="Draw" />
            </div>
          </div>
          <div className={styles['row']}>
            <div className={classnames({[styles['cell']]: true, [styles['cell-rest']]: true})}>
              <div className={classnames({
                [styles['arrow']]: true,
                [styles['arrow-down']]: true,
              })}></div>
              <div className={classnames({
                [styles['arrow']]: true,
                [styles['arrow-down-mobile']]: true,
              })}></div>
              <h5>2025</h5>
              {t('timeline.text2025')}
            </div>
            <div className={classnames({[styles['cell']]: true, [styles['cell-square']]: true})}>
              <div className={classnames({
                [styles['arrow']]: true,
                [styles['arrow-left']]: true,
              })}></div>
              <h2>2025</h2>
            </div>
          </div>
          <div className={styles['row']}>
            <div className={classnames({[styles['cell']]: true, [styles['cell-rest']]: true, [styles['cell-image']]: true})}>
              <img src={exploded} alt="Exploded View" />
            </div>
            <div className={classnames({[styles['cell']]: true, [styles['cell-square']]: true, [styles['cell-hidden']]: true})}></div>
          </div>
        </div>
      </div>
    </section>
  )
}
